import React, { useEffect } from 'react';
import { useAnalytics } from '../../../utils/analytics';
import { BaseStepPropsV2 } from '../../common/v2/BaseStepV2.types';
import { StepV2ConfirmButton } from '../../common/v2/StepV2ConfirmButton';
import { MainButtonVariant } from '../../styledComponent/Buttons.style';
import {
  InfoV1Screen,
  InfoV1ScreenContentWrapper,
  InfoV1ScreenCtaWrapper,
  InfoV1ScreenDescription,
  InfoV1ScreenEmail,
  InfoV1ScreenTexts,
  InfoV1ScreenTitle,
} from './InfoV1Step.style';
import { AbsoluteHeader } from '../../common/AbsoluteHeader/AbsoluteHeader';
import { useMst } from '../../../models/rootModel';
import { BaseStepV3 } from '../../common/v3/BaseStepV3';

interface InfoV1StepProps extends BaseStepPropsV2 {
  title: string;
  description: string;
  ctaButtonTitle: string;
  backgroundImageUrl: string;
  mobileViewBackgroundImageUrl: string;
  nextStepId?: string;
  email?: string;
}

export const InfoV1Step: React.FC<InfoV1StepProps> = (props) => {
  const {
    nextStep,
    goToNamedStep,
    ctaButtonTitle,
    isActive,
    title,
    description,
    backgroundImageUrl,
    mobileViewBackgroundImageUrl,
    previousStep,
    nextStepId,
    stepName,
    email,
  } = props;

  const analytics = useAnalytics();
  const { UserDiscoveryResponse } = useMst();

  useEffect(() => {
    if (isActive) {
      analytics.track(`view infoV1`, { stepName, segment: UserDiscoveryResponse.segment });
      return window.scrollTo(0, 0);
    }
  }, [analytics, isActive, UserDiscoveryResponse.segment, stepName]);

  const handleOnClick = () => {
    analytics.track(`click infoV1`, { stepName, segment: UserDiscoveryResponse.segment });

    if (nextStepId) {
      goToNamedStep(nextStepId);
    } else {
      nextStep();
    }
  };

  const onBack = () => {
    previousStep();
  };

  return (
    <BaseStepV3 {...props}>
      <InfoV1Screen imgDesktop={backgroundImageUrl} imgMobile={mobileViewBackgroundImageUrl}>
        <AbsoluteHeader onBack={onBack} color="white" />
        <InfoV1ScreenContentWrapper>
          <InfoV1ScreenTexts>
            <InfoV1ScreenTitle>{title}</InfoV1ScreenTitle>
            <InfoV1ScreenDescription dangerouslySetInnerHTML={{ __html: description }} />
            {email && <InfoV1ScreenEmail href={`mailto: ${email}`}>{email}</InfoV1ScreenEmail>}
          </InfoV1ScreenTexts>
          <InfoV1ScreenCtaWrapper>
            <StepV2ConfirmButton
              {...props}
              isButtonDisabled={false}
              isLoading={false}
              onClick={handleOnClick}
              ctaButtonTitle={ctaButtonTitle}
              variant={MainButtonVariant.White}
            ></StepV2ConfirmButton>
          </InfoV1ScreenCtaWrapper>
        </InfoV1ScreenContentWrapper>
      </InfoV1Screen>
    </BaseStepV3>
  );
};
